import { useEffect, useState } from 'react';

import LogoIcon from '@/component-library/primitives/Icons/LogoIcon/LogoIcon';

type LandingNavProps = {
  onWaitlistClick?: () => void;
  ctaLabel?: string;
};

function getAppScrollEl(): HTMLElement | null {
  return document.querySelector('.bg-custom-silver') as HTMLElement | null;
}

export default function LandingNav({ onWaitlistClick, ctaLabel = 'Join the waitlist' }: LandingNavProps) {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const scrollEl = getAppScrollEl();
    const handleScroll = () => {
      const y = scrollEl ? scrollEl.scrollTop : window.scrollY;
      setIsScrolled(y > 40);
    };

    handleScroll();
    scrollEl?.addEventListener('scroll', handleScroll, { passive: true });
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => {
      scrollEl?.removeEventListener('scroll', handleScroll);
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <nav
      className="fixed top-0 left-0 right-0 z-[9999] transition-all duration-300"
      style={{
        backgroundColor: isScrolled ? 'rgba(14, 28, 42, 0.92)' : 'rgba(14, 28, 42, 0.78)',
        backdropFilter: 'blur(14px)',
        WebkitBackdropFilter: 'blur(14px)',
        borderBottom: `1px solid ${isScrolled ? 'rgba(250, 250, 250, 0.08)' : 'rgba(250, 250, 250, 0.04)'}`,
        boxShadow: isScrolled ? '0 8px 32px rgba(0, 0, 0, 0.35)' : 'none',
      }}
    >
      <div className="max-w-6xl mx-auto px-6 py-5 flex items-center justify-between gap-6">
        <div className="block shrink-0" aria-hidden>
          <div
            className="transition-all duration-300"
            style={{ width: isScrolled ? '108px' : '124px', height: '32px' }}
          >
            <LogoIcon withText wordmarkColor="#FAFAFA" />
          </div>
        </div>

        {onWaitlistClick ? (
          <button
            type="button"
            onClick={onWaitlistClick}
            className="inline-flex items-center px-4 sm:px-5 py-2 sm:py-2.5 rounded-lg text-sm font-semibold transition-all duration-200 border border-medium hover:border-accent hover:bg-primary-subtle text-primary"
          >
            {ctaLabel}
          </button>
        ) : (
          <div className="w-[1px]" />
        )}
      </div>
    </nav>
  );
}
